import * as React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import PATHS from 'src/constants/paths';

import Logo from 'src/components/Logo';
import MPLink from 'src/components/MPLink';

import './styles.scss';

interface IFooterProps {
  className?: string;
}

declare const APP_VERSION: string;

const Footer: React.FunctionComponent<IFooterProps> = ({ className }) => {
  const cn = classNames('Footer', className);

  return (
    <footer className={cn}>
      <div className="Footer-leftContent">
        <div className="Footer-logo">
          <Logo iconColor="grey" />
          <span>Version: {APP_VERSION}</span>
        </div>
        <nav className="Footer-nav">
          <ul className="Footer-links">
            <li className="Footer-linkItem Footer-linkItem">
              <MPLink to={PATHS.FAQ.ROOT} isExternal={true}>
                <FormattedMessage id="containers.Footer.nav.faq" />
              </MPLink>
            </li>
            <li className="Footer-linkItem Footer-linkItem--terms">
              <MPLink to={PATHS.TERMS_AND_CONDITIONS} isExternal={true}>
                <FormattedMessage id="containers.Footer.nav.termsAndConditions" />
              </MPLink>
            </li>
            <li className="Footer-linkItem Footer-linkItem--contactUs">
              <MPLink to={PATHS.CONTACT_US} isExternal={true}>
                <FormattedMessage id="containers.Footer.nav.contactUs" />
              </MPLink>
            </li>
          </ul>
        </nav>
      </div>
    </footer>
  );
};

export default React.memo(Footer);



// WEBPACK FOOTER //
// ./src/containers/App/Layout/Footer/index.tsx